import type { Episode } from "@/types/movie";

interface EpisodeListProps {
  episodes: Episode[];
  activeIndex: number;
  onSelect: (index: number) => void;
}

export default function EpisodeList({ episodes, activeIndex, onSelect }: EpisodeListProps) {
  const active = episodes.find((e) => e.index === activeIndex) || episodes[0];

  return (
    <section>
      <h2 className="flex items-center gap-2 font-heading text-lg font-bold text-foreground-950 md:text-xl">
        <i className="ri-list-ordered text-xl text-primary-500"></i>
        剧集列表
        <span className="text-sm font-normal text-foreground-500">（共 {episodes.length} 集选集）</span>
      </h2>

      <div className="mt-4 grid grid-cols-3 gap-2 sm:grid-cols-4 md:grid-cols-6">
        {episodes.map((ep) => (
          <button
            key={ep.index}
            type="button"
            onClick={() => onSelect(ep.index)}
            className={`truncate whitespace-nowrap rounded-md px-3 py-2.5 text-sm transition-colors cursor-pointer ${
              ep.index === activeIndex
                ? "bg-primary-500 font-medium text-background-50"
                : "border border-background-300/70 text-foreground-700 hover:border-primary-300 hover:text-primary-600"
            }`}
          >
            第{ep.index}集
          </button>
        ))}
      </div>

      <div className="mt-4 rounded-lg border border-background-200/80 bg-background-100/70 p-4">
        <div className="flex items-center justify-between gap-3">
          <h3 className="text-sm font-medium text-foreground-900">{active.title}</h3>
          <span className="shrink-0 text-xs text-foreground-500">{active.duration}</span>
        </div>
        <p className="mt-2 text-sm leading-relaxed text-foreground-600">{active.summary}</p>
      </div>
    </section>
  );
}